import { render } from "./InfoFormReadOnly.vue?vue&type=template&id=27c955da&scoped=true"
import script from "./InfoFormReadOnly.vue?vue&type=script&lang=js"
export * from "./InfoFormReadOnly.vue?vue&type=script&lang=js"

import "./InfoFormReadOnly.vue?vue&type=style&index=0&id=27c955da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27c955da"]])

export default __exports__